import axiosServices from "../utils/axios";

import type { AisVessel, MysteryShip } from "../utils/types/aisVessels";

interface FetchApiResponse {
  data: AisVessel[];
}

export const fetchAisVesselList = async () => {
  const response = await axiosServices.get<FetchApiResponse>("/ais-vessels");
  return response.data;
};

export const addAisVesselToFleet = async (aisVesselId: string) => {
  const response = await axiosServices.post("/ais-vessels/add-to-fleet", {
    ais_vessel_id: aisVesselId,
  });
  return response.data;
};

// Mystery Ship placeholders

interface FetchMysteryShipResponse {
  data: MysteryShip[];
}

export const fetchMysteryShipList = async (locationId?: string) => {
  const params = locationId ? `?location_id=${encodeURIComponent(locationId)}` : "";
  const response = await axiosServices.get<FetchMysteryShipResponse>(
    `/mystery-ships${params}`
  );
  return response.data;
};

export const createMysteryShip = async (
  data: Omit<MysteryShip, "mystery_ship_id" | "created_dt" | "created_by">
) => {
  const response = await axiosServices.post("/mystery-ships", data);
  return response.data;
};

export const updateMysteryShip = async (
  mysteryShipId: string,
  data: Partial<MysteryShip>
) => {
  const response = await axiosServices.put(`/mystery-ships/${mysteryShipId}`, data);
  return response.data;
};

export const deleteMysteryShip = async (mysteryShipId: string) => {
  const response = await axiosServices.delete(`/mystery-ships/${mysteryShipId}`, {
    data: { mystery_ship_id: mysteryShipId },
  });
  return response.data;
};
